import { OfflineUnavailableMessage } from 'components/Offline';

/**
 * @method addWaterMarkToSvgCover
 */
const addWaterMarkToSvgCover = (frameDocument) => {
  const svgCovers = frameDocument?.querySelectorAll('.svgCover');
  let msgJsx = [];

  for (const svg of svgCovers) {
    let heightOfSvg = svg.scrollHeight;
    let top = +svg.style.top.split('px')[0];
    // if svg is not big enough to have 200px padding on top and bottom, divide available space
    if (heightOfSvg < 600) {
      msgJsx.push(
        <div
          style={{
            position: 'absolute',
            left: svg.style.left,
            top: top + 200,
            width: svg.scrollWidth,
            padding: `${(heightOfSvg - 200) / 2}px auto`,
          }}
        >
          <OfflineUnavailableMessage
            offlineAvailable={true}
            isPageUnavailable={true}
          />
        </div>,
      );
    }
    //Error message should repeat after 400px, paddingTop: 200px, errorMessage: 200px, paddingBottom: 200px
    while (heightOfSvg && heightOfSvg >= 600) {
      msgJsx.push(
        <div
          style={{
            position: 'absolute',
            left: svg.style.left,
            top: top + 200,
            width: svg.scrollWidth,
            padding: '200px auto',
          }}
        >
          <OfflineUnavailableMessage
            offlineAvailable={true}
            isPageUnavailable={true}
          />
        </div>,
      );
      heightOfSvg = heightOfSvg - 600;
      top = top + 600;
    }
  }

  return msgJsx;
};

export default addWaterMarkToSvgCover;
